import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { useCookies, withCookies } from "react-cookie";
import Footer from "../components/Footer";
import CalendarComponent from "../calendar/CalendarComponent";

const SplashComponent = ({ api }) => {

  const CakeEmoji = "\u{1F382}"

  const currentDate = new Date()
  const navigate = useNavigate()

  const [cookies] = useCookies([])
  const [userCount, setUserCount] = useState()
  const [randomBirthdays, setRandomBirthdays] = useState({});

  const getDaysInMonth = (date) => {
    const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const days = [];

    for (let i = 1; i <= endOfMonth.getDate(); i++) {
      days.push({
        date: new Date(date.getFullYear(), date.getMonth(), i),
        birthdays: randomBirthdays[i] ? CakeEmoji : null
      }
      );
    }

    return days;
  };

  const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const firstDayOfWeek = startOfMonth.getDay();
  const daysInMonth = getDaysInMonth(currentDate);
  const emptyDays = Array.from({ length: firstDayOfWeek }, (_, i) => i);

  useEffect(() => {
    if (cookies.token) {
      navigate('/home')
    }
  }, [cookies.token, navigate])

  useEffect(() => {
    generateRandomBirthdays();
  }, []);

  const generateRandomBirthdays = () => {
    const today = new Date();
    const totalDays = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();

    const birthdayIndexes = new Set();
    while (birthdayIndexes.size < 5) {
      birthdayIndexes.add(Math.floor(Math.random() * totalDays) + 1);
    }

    const birthdayMap = {}
     Array.from(birthdayIndexes).forEach(day => {
      birthdayMap[day] = "s"
    });

    setRandomBirthdays(birthdayMap);
  };

  useEffect(() => {
    (async () => {
      if (!cookies.token) {
        try {
          const resp = await api().getUserCount()
          if (resp.status === 200) {
            setUserCount(resp.data.count)
          }
        } catch (e) {

        }
      }
    })()
  }, [cookies.token])

  return (
    <div>
      <Header api={api} />
      <div className="bg-gradient-to-b from-blue-400 to-green-700 text-white h-screen flex items-center justify-center pt-20">
        <div className="text-center space-y-6">
          {/* Title */}
          <h1 className="text-5xl md:text-6xl font-extrabold">
            wait, when's your birthday?
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-gray-200">
            never forget a friends' birthday
          </p>

          {/* Call-to-Action Button */}
          <button className="px-6 py-3 bg-white text-blue-700 font-medium rounded-xl shadow-lg hover:bg-gray-100 transition">
            <a href={cookies.token ? "/home" : "/login"}>{cookies.token ? "home" : "get started"}</a>
          </button>
          {userCount && !cookies.token ?
            <p className="pt-20 md:text-xl text-gray-200">
              {`join ${userCount} other people remembering birthdays`}
            </p> : <div />}

          {true && <div className="absolute bottom-10 flex flex-col items-center space-y-2">
            <p className="text-gray-200 text-sm md:text-base">learn more</p>
            <a href="#features" className="scroll-smooth">
              <svg className="w-8 h-8 text-gray-200 animate-bounce" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"></path>
              </svg>
            </a>
          </div>}
        </div>
      </div>
      {/* Features Section */}
      {true && <section id="features" className="py-16 bg-gray-100 text-center">
        <h2 className="text-3xl font-bold text-gray-800">wait, when's your birthday?</h2>
        <p className="mt-4 text-lg text-gray-600">Helping you keep track of all your friends' birthdays, in one place</p>

      
        {/* Feature 1: Calendar */}
        <div className="mt-10 flex flex-col md:flex-row items-center justify-center px-6">
          <div className="w-full md:w-1/2">
            <CalendarComponent
              monthName="February"
              year={2024}
              prevMonth={() => console.log("Previous month")}
              nextMonth={() => console.log("Next month")}
              emptyDays={emptyDays}
              daysInMonth={daysInMonth}
              today={currentDate}
              handleDateClick={(day) => console.log("Selected Date:", day)}
            />
          </div>
          <div className="w-full md:w-1/3 text-left">
            <h3 className="text-2xl font-semibold text-gray-800">
              Never miss a birthday again
            </h3>
            <p className="mt-4 text-lg text-gray-600">
              Connect with your friends, and their birthdays are automatically added to your calendar. See everyone's birthday, in one place,
              so you never forget again.
            </p>
          </div>
        </div>

    
        <div className="mt-16 flex flex-col md:flex-row-reverse items-center justify-center gap-20 px-6">
          <div className="text-6xl">🔒</div>
          <div className="w-full md:w-1/3 text-left">
            <h3 className="text-2xl font-semibold text-gray-800">
              Built with your privacy in mind
            </h3>
            <p className="mt-4 text-lg text-gray-600">
              You have full control over who can see your birthday - your profile can be public, 
              so anyone can see, or private, so only those who you allow can see your birthday.
            </p>
          </div>
        </div>


        {/* Feature 3: Placeholder Feature */}
        <div className="mt-16 flex flex-col md:flex-row items-center justify-center gap-20 px-6">
          <div className="text-6xl">📧🎂</div>
          <div className="w-full md:w-1/3 text-left">
            <h3 className="text-2xl font-semibold text-gray-800">
              Stay in the loop
            </h3>
            <p className="mt-4 text-lg text-gray-600">
              We'll send you an email at the start of every month to remind you whose birthdays are coming up. You can turn this feature off if
              you're aiming for inbox zero.
            </p>
          </div>
        </div>
      </section>}
    </div>
  );
}

const Splash = withCookies(({ api }) => (
  <div>
    <SplashComponent api={api} />
    <Footer />
  </div>
))

export default Splash;